export const rebateOfferAssets = {
	backgroundLandscape: "/spec_rebate_offer/bg-landscape.png",
	backgroundPortrait: "/spec_rebate_offer/bg-portrait.png",
	earnBox: "/spec_rebate_offer/earn-box.png",
	icon: "/spec_rebate_offer/rebate-icon-v3.gif",
	rewardCircle: "/spec_rebate_offer/reward-circle.png"
} as const;
